/**
 * @author Fernando FH
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class TelemedicineHistoryService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(
      ServiceConstant.TELEMEDICINE_LIST_HISTORY_PAGINATION,
      params
    );
  }

  static get(params) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_GET_HISTORY, params);
  }

  static getColposcopy(params) {
    return this.postSEC(ServiceConstant.COLPOSCOPY_GET_HISTORY, params);
  }

  static update(params) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_UPDATE_HISTORY, params);
  }

  static updateMultipart(formData) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_UPDATE_HISTORY, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  static updateDiagnosis(params) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_UPDATE_DIAGNOSIS, params);
  }

  static pdf(params) {
    return this.postPDFSEC(ServicePath.TELEMEDICINE_PDF, params);
  }
}
